export const INITIALIZE = 'INITIALIZE'
export const GAME_PAUSE_TOGGLE = 'GAME_PAUSE_TOGGLE'

export const DIVISIONS_SET_TARGET = 'DIVISIONS_SET_TARGET'
export const DIVISIONS_HOVER = 'DIVISIONS_HOVER'
export const DIVISIONS_CHOOSE = 'DIVISIONS_CHOOSE'